// extracted by mini-css-extract-plugin
export default {"root":"styles-root-aed0e2","content":"styles-content-ff5ced","icon":"styles-icon-b67255","title":"styles-title-bda27d","instructions":"styles-instructions-f74f7c"};